<lib-dynamic-listing
  [module]="'client'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  [columnPreferenceId]="columnPreferenceId"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()"
  (columnsSelected)="onColumnsSelected($event)"
  (columnPreferenceSaved)="onColumnPreferenceSaved($event)">
</lib-dynamic-listing>

